import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IActionErrorInfo } from "../../jobs/types/IActionErrorInfo";
import { editTicketGridTemplate } from "../thunks/editTicketGridTemplate";
import { ITicketGridsState } from "../types/ITicketGridsState";
import { ReportStatus } from "../../reports/types/reportStatus";
import { mapReportPramsToReportInfo } from "./utils/mapReportPramsToReportInfo";

export const addEditTicketGridTemplate = (
  builder: ActionReducerMapBuilder<ITicketGridsState>,
) => {
  builder.addCase(editTicketGridTemplate.pending, (state, action) => {
    state.loadingReportKeys = [
      ...state.loadingReportKeys,
      `${action.meta.arg.id}`,
    ];
    state.ticketGridsCreating = true;
  });
  builder.addCase(editTicketGridTemplate.rejected, (state, action) => {
    state.ticketGridsCreating = false;
    state.loadingReportKeys = state.loadingReportKeys.filter(
      (id) => id !== `${action.meta.arg.id}`,
    );
    const error: IActionErrorInfo = {
      id: Date.now(),
      message: `Ошибка редактирования ${
        action.meta.arg.status === ReportStatus.template
          ? "шаблона"
          : "задачи"
      } ID: ${action.meta.arg.id}!: ${action.error.message}`,
    };
    state.errors = [...state.errors, error];
  });
  builder.addCase(editTicketGridTemplate.fulfilled, (state, action) => {
    state.ticketGridsCreating = false;
    state.loadingReportKeys = state.loadingReportKeys.filter(
      (id) => id !== `${action.meta.arg.id}`,
    );
    state.templates = state.templates.map((r) => {
      if (r.id == action.meta.arg.id) {
        return mapReportPramsToReportInfo(r, action.meta.arg);
      }
      return r;
    });
  });
};
